import { InfluencerPlan } from '@round/api';
import { ActionCard, assets } from '@round/whitelabel-ui';
import { Link } from 'react-router-dom';
import styles from './RoundPlan.module.css';

const { LogoShort: RoundLogoShort } = assets;

type Props = {
    plan: InfluencerPlan;
};

const RoundPlan = ({ plan }: Props) => {
    const releaseId = plan.release.id;
    const roundPlanUrl = `/campaigns/${releaseId}/creators`;
    const brandInfo = `${plan.release.brand.name} | ${plan.release.brand.client.name}`;

    return (
        <Link to={roundPlanUrl} className={styles.link}>
            <ActionCard
                title={plan.release.name}
                subTitle={brandInfo}
                actionLabel="View on Round"
                Icon={RoundLogoShort}
            />
        </Link>
    );
};

export default RoundPlan;
